import home, { getStaticProps as homeGetStaticProps } from './home'

export const getStaticProps = homeGetStaticProps

export default home
